export const habaCart = {
  habaAddToCartPopup: {
    headline: 'Artikel zum Warenkorb hinzugefügt',
    toCart: 'Warenkorb ansehen',
    continue: 'Weiter einkaufen',
    recommendationsTitle: 'Produkte die Sie auch interessieren könnten',
    add: 'Hinzufügen',
    added: 'Hinzugefügt',
    quantity: 'Menge:',
  },

  habaVoucher: {
    coupon: 'Sie haben einen Gutschein oder eine Vorteilsnummer?',
    apply: 'Einlösen',
    placeholder: 'Nummer eingeben',
    error: 'Bitte geben Sie einen gültigen Code ein.',
    applyVoucherSuccess: '{{voucherCode}} wurde erfolgreich eingelöst.',
    removeVoucherSuccess: '{{voucherCode}} wurde entfernt.',
    availableCoupons: 'Einlösbare Coupons',
    availableCouponsLabel: 'Du kannst diese Coupons deiner Bestellung hinzufügen.',
    vouchersApplied: 'Eingelöste Gutscheine:',
    promotionInfo: {
      headline: 'Alle Informationen und Bedingungen',
      labelPromo: 'Vorteilscode',
      labelCampaign: 'Kampagne',
    },
    giftCardInsolvencyInputMessageFindMore: 'Hier findest du weitere Informationen.',
    giftCardInsolvencyClose: 'Schliessen',
    giftCardInsolvencySorryMessage: 'Es tut uns leid!',
    giftCardInsolvencyMessage1:
      'Unser Unternehmen befindet sich zur Zeit im Insolvenzverfahren in Eigenverwaltung.',
    giftCardInsolvencyMessage2: 'Wenn der Gutschein vor dem 12.09.2023 erworben wurde, ist das ',
    giftCardInsolvencyMessage3:
      'Guthaben Teil des Verfahrens und kann leider momentan nicht eingelöst werden.',
    giftCardInsolvencyMessage4:
      'Als kleine Entschuldigung haben wir einen Sonder-Rabatt zu deinem Warenkorb hinzugefügt.',
    giftCardInsolvencyMessage5:
      'Nach der Eröffnung des Eigenverwaltungsverfahrens (voraussichtlich am 01.12.2023) kannst du deine Forderung in der Insolvenztabelle anmelden und geltend machen.',
    disabledGiftcardsMessage:
      'Vorteilscodes und Gutscheine können derzeit leider nicht verwendet werden. Die Funktion steht bald wieder zur Verfügung.',
  },

  habaMiniCart: {
    cart: 'Warenkorb',
    title: 'Dein Warenkorb',
    emptyCart: 'Warenkorb leer.',
    viewCart: 'Warenkorb ansehen',
    anonymousPopup: {
      headline: 'Vermisst Du deine Produkte?',
      text: 'Melde Dich an, um deine letzten Produkte im Warenkorb zu sehen.',
      headlineHaba: 'Vermisst du Deine Produkte?',
      textHaba:
        'Melde dich mit deinem Kundenkonto an und profitiere von Schnellbestellungen und Rabatten.',
      button: 'Anmelden',
    },
    emptyCartPopupText: 'Du hast keien Artikel in deinem Warenkorb.',
    emptyCartPopupTextHaba: 'Sie haben keine Artikel in Ihrem Warenkorb',
  },
  habaCart: {
    emptyCartTitle: 'Dein Warenkorb',
    emptyCartDescription:
      'Füge Produkte zum Warenkorb hinzu, indem du im Shop stöberst und Produkte zum Warenkorb hinzufügst.',
    emptyCartButtonText: 'Jetzt losstöbern',
    myCart: 'Mein Warenkorb',
    toHome: 'Zur Startseite',
    payPalExpressInfo: 'Schnell bezahlen & bestellen mit',
    informationAndConditions: 'Alle Informationen und Bedingungen',
    backToCart: 'Zurück zum Warenkorb',
  },
  cartProductReplaceErrors: {
    quantityReduced:
      'Die gewünschte Menge ist leider nicht mehr verfügbar. Die maximal verfügbare Menge wurde angepasst.',
    maxOrderQuantityExceeded: 'Angeforderte Mengen nicht mehr verfügbar. Mengen geändert.',
    productNotFound: 'Leider ist das Produkt nicht verfügbar.',
    lowStock:
      'Es tut uns leid, aber das gewünschte Produkt ist in der Zwischenzeit nicht mehr verfügbar.',
  },
  habaCartDetails: {
    productsValue: 'Warenwert',
    details: {
      initialPrice: 'Ursprünglicher Warenwert',
      reductions: 'Ihre Ersparnisse',
      currentPrice: 'Warenwert',
      currentPriceDetails: '(alle Aktionen angewendet)',
      returnVoucher: 'Gutscheineinlösung',
      deliveryCost: 'Versandkosten (kostenfrei ab {{amount}})',
      total: 'Gesamtsumme',
    },
  },
};
